module.exports = __webpack_public_path__ + "img/left_box_img.91486bd8.png";